import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import IMG1 from "../../../images/industries/healthcare/HL7.png";
import IMG2 from "../../../images/industries/healthcare/EMR.png";
import IMG3 from "../../../images/industries/healthcare/Bedside-Monitoring.png";
import IMG4 from "../../../images/industries/healthcare/HIPAA.png";
import IMG5 from "../../../images/industries/healthcare/PACS.png";
import IMG6 from "../../../images/industries/healthcare/Pharmaceutical.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Demandfeatures(props) {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";
  return (
    <section className="p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Transformative">
              <h2>Avail Our Integrated Digital Health Services</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Having a futuristic approach, we are committed to delivering
              innovative digital healthcare solutions to healthcare providers,
              clinicians, and organizations.
            </p>
            <p>
              We have built each digital healthcare solution by integrating the
              latest tech-based systems to ensure a valuable outcome. As one of
              the pioneering digital healthcare companies, we offer expert
              healthcare integration solutions:
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                0,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(0)}
            >
              <LazyLoadImage
                src={IMG1}
                effect="blur"
                className="img-fluid"
                alt="Health Level 7"
              />
              <h6>HL7 </h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                1,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(1)}
            >
              <LazyLoadImage
                src={IMG2}
                effect="blur"
                className="img-fluid"
                alt="EHR integration services"
              />
              <h6>EMR </h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                2,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(2)}
            >
              <LazyLoadImage
                src={IMG3}
                effect="blur"
                className="img-fluid"
                alt="BEDSIDE MONITORING"
              />
              <h6>BEDSIDE MONITORING</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                3,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(3)}
            >
              <LazyLoadImage
                src={IMG4}
                effect="blur"
                className="img-fluid"
                alt="HIPAA-HITECH"
              />
              <h6>HIPAA-HITECH</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                4,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(4)}
            >
              <LazyLoadImage
                src={IMG5}
                effect="blur"
                className="img-fluid"
                alt="PACS systems"
              />
              <h6>PACS </h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                5,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(5)}
            >
              <LazyLoadImage
                src={IMG6}
                effect="blur"
                className="img-fluid"
                alt="pharmaceutical solutions"
              />
              <h6>PHARMACEUTICAL </h6>
            </div>
          </Col>

          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 0
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              We aim to accelerate innovation in healthcare technology by
              optimizing digital health solutions. Our experts have successfully
              transformed digital health with data sharing with our customized
              HL7 (Health Level 7) standard integration solutions. With secure
              patient data integration between healthcare systems, our software
              provides a complete view of patient health. Meanwhile, our HL7
              integration services ensure smooth communication capabilities to
              improve patient outcomes. We have been providing custom digital
              healthcare solutions for:
              <div className="new-solutionlist padding_top_extra">
                <ul>
                  <li>HL7 Messaging</li>
                  <li>HL7 Data Exchange</li>
                  <li>HL7 Specification Model</li>
                  <li>HL7 Integration Engine</li>
                  <li>HL7 Integration Development</li>
                </ul>
              </div>
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 1
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              We offer efficient EHR integration services based on efficient
              integration platforms. Our EMR integration solutions use
              standardized regulations, such as HL7 and FHIR. These regulations
              optimize data exchange between systems. With our EMR digital
              health solutions, we help healthcare providers ensure the best
              care possible by streamlining processes and improving
              communication. Our team is dedicated to providing customized
              support to our clients, validating their success in achieving the
              most professional digital healthcare solutions. We aim to craft
              innovative healthcare solutions with EMR integration services:
              <div className="new-solutionlist padding_top_extra">
                <ul>
                  <li>Extensive Interface Development</li>
                  <li>Streamlined Data Conversione</li>
                  <li>Fast Integration Framework</li>
                  <li>Interface Issue Troubleshooting & Assistance</li>
                  <li>EHR Interface Services & Problem Solving.</li>
                </ul>
              </div>
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 2
                  ? "industries_content d-block"
                  : "content d-none"
              }
              i
            >
              Improvise the healthcare integration with our reliable and
              clinically-focused digital healthcare solutions for bedside
              patient monitoring systems. We offer integrated solutions for
              healthcare operations to provide access to data conveniently and
              securely. The digital solutions in healthcare we design and
              develop, integrate critical messaging, workflows, instantaneous
              location, and reporting into a single-source solution for remote
              patient monitoring devices. Our bedside and remote patient
              integration solutions are designed to offer you the following:
              <div className="new-solutionlist padding_top_extra">
                <ul>
                  <li>Seamless Integration Of Data,</li>
                  <li>Instantaneous Monitoring Of Patients’ Data</li>
                  <li>Enhanced patient Data Accuracy And Comprehensiveness</li>
                  <li>Optimized Patient Autonomy And Engagement</li>
                  <li>Better Resource Utilization And Cost Savings.</li>
                </ul>
              </div>
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 3
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Our HIPAA-HITECH compliant video & communication healthcare
              service provides secure and reliable video communication
              solutions. Leveraging this digital healthcare platform, we
              facilitate healthcare providers to interact with patients easily,
              hence promoting patient engagement. This advanced digital health
              solution is quite effortless and secure. Moreover, it is based on
              advanced security protocols to protect patient confidential
              information. The primary attributes of TekRevol’s HIPAA-HITECH
              compliant video and communication service include:
              <div className="new-solutionlist padding_top_extra">
                <ul>
                  <li>Fully-Encrypted Secure Video Conferencing</li>
                  <li>
                    Multi-Platform Support Across Multiple Devices And Operating
                    Systems
                  </li>
                  <li>
                    Integration With Electronic Health Record (Ehr) Systems
                  </li>
                  <li>Advanced Scheduling Feature</li>
                  <li>Robust Patient Engagement Tools</li>
                </ul>
              </div>
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 4
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              We offer innovative solutions for digital health with efficient
              integration for PACS systems by understanding the preferences of
              healthcare providers. Our support team works with you to
              understand your workflows and implement solutions smoothly with
              your existing infrastructure. Moreover, our PACS Integration
              Solutions helps healthcare providers optimize workflows and
              improve patient care by understanding the significance of
              efficient data flow. This digital health technology reduces
              administrative burdens and offers providers extensive patient
              care. Our service includes:
              <div className="new-solutionlist padding_top_extra">
                <ul>
                  <li>End-to-end integration solutions with PACS systems.</li>
                  <li>Custom Integration Solutions</li>
                  <li>Ongoing system maintenance and support</li>
                  <li>Scalable solutions</li>
                  <li>
                    Full compliance with industry standards, including HIPAA
                  </li>
                </ul>
              </div>
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 5
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              TekRevol's health IT solutions help you achieve more significant
              clinical research. Our pharmaceutical solutions help streamline
              clinical research and trials, allowing for improved patient
              monitoring in a remote setting. Hence, with our pharmaceutical
              solutions, you can focus on the core of your research and leave
              the rest to us. Our telemedicine solutions service includes:
              <div className="new-solutionlist padding_top_extra">
                <ul>
                  <li>HIPAA-compliant Video consultations</li>
                  <li>Remote patient monitoring</li>
                  <li>Electronic health records</li>
                  <li>Seamless Mobile applications</li>
                  <li>Comprehensive training and support services</li>
                </ul>
              </div>
              <div className="btn_talk sol-btn">
                <Link
                  to="/contact"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  Let’s Connect!
                </Link>
              </div>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Demandfeatures;
